//@flow
import React from "react";

export type percentFractionIndicatorType = {
  percent: number,
  threshold: number,
  showFractions: boolean,
  total: number,
  max: number,
  withoutWarningColor?: boolean,
};

export default function percentFractionIndicator({
  percent,
  threshold,
  showFractions,
  total,
  max,
  withoutWarningColor,
}: percentFractionIndicatorType) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <div
        style={{
          lineHeight: "20px",
          color: percent >= (threshold || 80) || withoutWarningColor ? "#555555" : "#ff0000",
          fontWeight: percent >= (threshold || 80) ? "700" : "400",
        }}
      >
        {percent}%
      </div>
      {showFractions ? (
        <div style={{ lineHeight: "20px", color: "#555555a1" }}>{`(${total} / ${max})`}</div>
      ) : (
        ""
      )}
    </div>
  );
}
